export default "__VITE_ASSET__Dj_DCYix__"